import type { StorageLocationsOverviewParams } from 'src/apis/storage/types';

/** Params for fetching locations list (e.g. for create/edit form dropdowns). */
export const storageLocationsDefaultParams: StorageLocationsOverviewParams = {
  offset: 0,
  limit: 100,
};

/** Params for fetching locations list for offer creation. */
export const storageLocationsOfferCreateParams: StorageLocationsOverviewParams =
  {
    ...storageLocationsDefaultParams,
    ownLocations: true,
  };

export const MAX_MARKET_AREAS = 2;
